import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { formatDate, truncateText } from '../utils/helpers';
import ImageWithFallback from './ImageWithFallback';

const StoryCard = ({ story }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="card group"
    >
      <Link to={`/stories/${story.slug}`} className="block">
        {/* Image */}
        <div className="relative overflow-hidden">
          <ImageWithFallback
            src={story.image}
            alt={story.title}
            className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
            width={400}
            height={250}
          />
          <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-30 transition-all duration-300" />
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Meta Info */}
          <div className="flex items-center justify-between text-sm text-secondary-500 dark:text-secondary-400 mb-3">
            <span>{story.author}</span>
            <div className="flex items-center space-x-2">
              <span>{story.readingTime} min read</span>
              <span>•</span>
              <span>{formatDate(story.date)}</span>
            </div>
          </div>

          {/* Title */}
          <h3 className="text-xl font-bold text-secondary-900 dark:text-white mb-3 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors duration-200">
            {story.title}
          </h3>

          {/* Excerpt */}
          <p className="text-secondary-700 dark:text-secondary-300 text-sm leading-relaxed mb-4">
            {truncateText(story.excerpt, 120)}
          </p>

          {/* Tags */}
          <div className="flex flex-wrap gap-2 mb-4">
            {story.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-2 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 dark:bg-secondary-700 dark:text-secondary-300 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>

          {/* Read More Link */}
          <div className="flex items-center text-primary-600 dark:text-primary-400 font-medium text-sm group-hover:text-primary-700 dark:group-hover:text-primary-300 transition-colors duration-200">
            <span>Read Story</span>
            <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default StoryCard;
